const PAGE_SIZE = 1000;
const MAX_ROWS = 50000;

/**
 * Read a complete, account/run-scoped result set through PostgREST. A hard
 * upper bound fails explicitly instead of silently presenting truncated data.
 */
async function readPages(supabase, table, columns, filters, orderColumns) {
  const rows = [];
  for (let from = 0; ; from += PAGE_SIZE) {
    const to = Math.min(from + PAGE_SIZE - 1, MAX_ROWS - 1);
    let query = supabase.from(table).select(columns);
    for (const [column, value] of filters) query = query.eq(column, value);
    for (const column of orderColumns) query = query.order(column, { ascending: true, nullsFirst: true });
    const { data, error } = await query.range(from, to);
    if (error) throw error;
    const page = data || [];
    rows.push(...page);
    if (page.length < to - from + 1) return rows;
    if (from + page.length >= MAX_ROWS) {
      let overflowQuery = supabase.from(table).select(columns);
      for (const [column, value] of filters) overflowQuery = overflowQuery.eq(column, value);
      const { data: overflow, error: overflowError } = await overflowQuery.range(MAX_ROWS, MAX_ROWS);
      if (overflowError) throw overflowError;
      if (overflow?.length) throw new Error("Local competitor evidence exceeded the safe read limit.");
      return rows;
    }
  }
}

export async function loadLocalCompetitorRadarData(supabase, accountId, runId) {
  if (!accountId || !runId) return { roles: [], mentions: [] };

  const [roles, mentions] = await Promise.all([
    readPages(
      supabase,
      "account_entity_roles",
      "id,account_id,canonical_entity_key,display_name,normalized_entity_name,raw_entity_name,entity_role,score_treatment,visibility_treatment,is_active,review_status,approved_at,source",
      [["account_id", accountId]],
      ["canonical_entity_key", "id"]
    ),
    readPages(
      supabase,
      "toren_local_entity_mentions",
      "account_id,run_id,local_prompt_category,prompt_result_id,entity_name,is_business_entity,is_comparison_prompt,visibility_signal",
      [["account_id", accountId], ["run_id", runId], ["is_business_entity", false], ["is_comparison_prompt", false]],
      ["prompt_result_id", "local_prompt_category", "entity_name"]
    ),
  ]);

  return { roles, mentions };
}

export const LOCAL_COMPETITOR_RADAR_PAGE_SIZE = PAGE_SIZE;
export const LOCAL_COMPETITOR_RADAR_MAX_ROWS = MAX_ROWS;
